<!-- 1depth: 범주 목록 -->
<ng-container *ngIf="!selectedCat">
  <a *ngFor="let cat of catIndexList"
     class="page-navigation-btn"
     role="button"
     (click)="onClickCat($event, cat)">{{ cat.name }}</a>
</ng-container>

<!-- 2depth: 선택된 범주의 조사 목록 -->
<ng-container *ngIf="selectedCat">
  <a class="page-navigation-btn depth2 return"
     role="button"
     aria-label="뒤로"
     (click)="onClickReturn($event)">
    <div class="return-icon"></div>
  </a>
  <a class="page-navigation-btn depth2 depth2-heading"
     role="button"
     [class.on]="!selectedPostposition"
     [attr.aria-current]="!selectedPostposition ? 'true' : null"
     (click)="onClickCatAll($event)">{{ selectedCat.name }}</a>
  <a *ngFor="let pp of displayList"
     class="page-navigation-btn depth2"
     role="button"
     [class.on]="selectedPostposition?.id === pp.id"
     [attr.aria-current]="selectedPostposition?.id === pp.id ? 'true' : null"
     (click)="onClickPostposition($event, pp)">{{ pp.name }}</a>
</ng-container>
